import React, { useState, useEffect } from 'react';
import { Flex, Row, Col, Statistic, Card } from 'antd'
import { CheckSquareFilled, MobileFilled, UserOutlined, BankFilled, StopFilled, ClockCircleFilled, CloseCircleFilled, WarningFilled } from '@ant-design/icons';
import StatisticComponent from './dashboard/StatisticComponent';
import { useSchool } from '../hook/SchoolHook';
import { useCustomer } from '../hook/CustomerHook';
import { CUSTOMER_STATUS } from '../objects/CustomerObject';
import CanvasJSReact from '@canvasjs/react-charts';
import { useScreenConfig } from '../hook/GameConfigHook';
import { isMobile } from 'react-device-detect';

var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

export default function SC01_HomeScreen(props) {
    const { schools } = useSchool()
    const { customers } = useCustomer()
    const { screens } = useScreenConfig()
    const [totalSchool, setTotalSchool] = useState(0)
    const [total, setTotal] = useState(0)
    const [active, setActive] = useState(0)
    const [play, setPlay] = useState(0)
    const [check, setCheck] = useState(0)
    const [expired, setExpired] = useState(0)
    const [block, setBlock] = useState(0)
    const [pending, setPending] = useState(0)
    const [gameStats, setGameStats] = useState(null)

    useEffect(() => {
        if (schools && Array.isArray(schools)) {
            setTotalSchool(schools.length)
        }
    }, [schools])

    useEffect(() => {
        if (customers && Array.isArray(customers)) {
            setTotal(customers.length)
            let numberExpired = 0
            let numberBlock = 0
            let numberPending = 0
            let numberCheck = 0
            let numberActive = 0
            let numberPlay = 0
            const screenConfig = []
            if (screens && Array.isArray(screens)) {
                screens.forEach(screen => {
                    screenConfig.push({ label: screen.name, y: 0, key: screen.key })
                })
            }
            console.log("SCREENS AFTER: ", screenConfig)

            customers.forEach(user => {
                switch (user.status) {
                    case CUSTOMER_STATUS.ACTIVE.key: numberActive++; break;
                    case CUSTOMER_STATUS.DISABLED.key: numberPending++; break;
                    case CUSTOMER_STATUS.BLOCKED.key: numberBlock++; break;
                    case CUSTOMER_STATUS.DRAFT.key: numberCheck++; break;
                    case CUSTOMER_STATUS.EXPIRED.key: numberExpired++; break;
                }
                if (user.deviceName) {
                    numberPlay++;
                }
                if (user.played) {
                    Object.keys(user.played).forEach(game => {
                        const scIndex = screenConfig.findIndex(s => s.key === game);
                        if (scIndex != -1) {
                            screenConfig[scIndex].y += user.played[game]
                        }
                    })
                }
            });
            // console.log("SCREENS: ", screenConfig)

            const options = {
                animationEnabled: true,
                title: {
                    text: "Số lượt chơi mỗi game (Chơi đủ 10 câu hỏi trong 1 game) ",
                    fontFamily: "tahoma",
                    fontSize: isMobile?18:26,
                    marginBottom:10
                },
                axisX: {
                    interval: 1,
                    titleFontSize: isMobile?11:14,
                    labelFontSize:isMobile?11:14,
                },
                height: isMobile?680:560,
                axisY2: {
                    interlacedColor: "rgba(98, 184, 197, 0.2)",
                    gridColor: "rgba(58, 116, 134, 0.1)",
                    // title: "Số lượt chơi",
                    titleFontSize: isMobile?11:14,
                    labelFontSize:isMobile?12:16,
                    interval: 1
                },
                dataPointWidth:24,
                data: [
                    {
                        type: "bar",
                        name: "Trò chơi",
                        color: "#4e73df",
                        axisYType: "secondary",
                        dataPoints: screenConfig
                    }
                ]
            }
            setGameStats(options)

            setActive(numberActive)
            setPending(numberPending)
            setBlock(numberBlock)
            setExpired(numberExpired)
            setPlay(numberPlay)
            setCheck(numberCheck)
        }
    }, [customers, screens])

    return (
        <div>
            <Flex wrap gap={isMobile?"small":"large"}>
                <StatisticComponent title="Trường học" value={totalSchool} color="#6200ea" icon={<BankFilled />} />
                <StatisticComponent title={isMobile?"Số học sinh":"Tổng số Học sinh"} value={total} color="#9c27b0" icon={<UserOutlined />} />
                <StatisticComponent title="Đang hoạt động" value={active} color="#4e73df" icon={<CheckSquareFilled />} />
                <StatisticComponent title="Đã chơi game" value={play} color="#1cc88a" icon={<MobileFilled />} />
                <StatisticComponent title="Chờ xác minh" value={check} color="#36b9cc" icon={<WarningFilled />} />
                <StatisticComponent title="Hết hạn" value={expired} color="#f6c23e" icon={<ClockCircleFilled />} />
                <StatisticComponent title="Tạm ngừng" value={pending} color="#5a5c69" icon={<StopFilled />} />
                <StatisticComponent title="Bị khoá" value={block} color="#e74a3b" icon={<CloseCircleFilled />} />
            </Flex>
            <div style={{ marginTop: "25px", padding: isMobile?"5px":"20px", borderRadius: "10px", backgroundColor: "white" }}>{gameStats ? <CanvasJSChart options={gameStats} /> : null}</div>
        </div>
    )
}